import styled from 'styled-components';

export const ToolbarContainer = styled.div`
  background-color: var(--ds-surface, --ds-fb-surface);
  z-index: 50 !important;
  width: fit-content;
  position: relative;
`;

export const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;

  width: fit-content;
  background-color: var(
    --ds-background-accent-gray-subtler,
    var(--ds-fb-background-accent-gray-subtler)
  );
  border-radius: 3px;
  margin-top: 4px;

  button {
    margin: 0px;
    padding: 0px;
    border: 0px;
    width: 24px;
    height: 24px;
    color: var(--ds-icon, --ds-fb-icon);
    background-color: var(
      --ds-background-accent-gray-subtler,
      var(--ds-fb-background-accent-gray-subtler)
    );
    &:hover {
      cursor: pointer;
      background-color: var(
        --ds-background-accent-gray-subtlest,
        var(--ds-fb-background-accent-gray-subtlest)
      );
      border-radius: 3px;
    }
  }
`;

export const ButtonWrapper = styled.div`
  div {
    height: 24px;
  }
  margin: 4px;
`;
